import { ClickMenuItem, Icon, IconName } from '../../../components';
import { ShortcutLegendIcon } from '../../../components/ShortcutLegendIcon';

interface PresentationViewOptionListItemProps {
  label: string;
  onClick: () => void;
  prefix?: JSX.Element;
  icon: IconName | false | undefined;
  className?: string;
  shortcutCharacter?: string;
}

export function PresentationViewOptionListItem({
  icon,
  label,
  prefix,
  onClick,
  className,
  shortcutCharacter,
}: PresentationViewOptionListItemProps) {
  return (
    <ClickMenuItem className={className} onClick={onClick}>
      <div className="flex items-center">
        {prefix}
        <span className="text-white text-lg tracking-[0.134px] leading-[normal]">{label}</span>
        <ShortcutLegendIcon shortcutCharacter={shortcutCharacter} />
      </div>

      {icon && <Icon className="text-palette-600" icon={icon} />}
    </ClickMenuItem>
  );
}
